import React, {useRef, useEffect, useState} from 'react';
import {useSelector} from 'react-redux';

// Components
import Line from './components/Line';

// Utils
import {getOffset} from 'Utils';

// Selectors
// import {
//     getArrActionGoToOtherAction, getNodeHeights,
//     getStatusGoToOtherAction
// } from 'Modules/Workflow/containers/MyWorkflow/containers/Workflow/Design/selectors';

// Styled
import {LineArrowSvg, ArrowSvg} from 'Components/flowChart/components/LineArrow/index.style.js';

const LineArrow = (props) => {
    const {
        arrActionGoToOtherAction = [],
        statusGoToOtherAction = {}
    } = props;

    const containerRef = useRef(null);
    const execute = useRef(null);
    const [offsetContainer, setOffsetContainer] = useState({
        left: 0,
        top: 0
    });

    useEffect(() => {
        if (containerRef.current) {
            // const rectContainer = getOffset(containerRef.current);

            // if (rectContainer.left !== offsetContainer.left || offsetContainer.top !== rectContainer.top) {

            //     setOffsetContainer(rectContainer);
            // }

            if (containerRef.current) {
                const rectContainer = getOffset(containerRef.current);

                if (rectContainer.left !== offsetContainer.left || offsetContainer.top !== rectContainer.top) {

                    setOffsetContainer(rectContainer);
                }
            }
        }
    });

    return <LineArrowSvg ref={containerRef}>
        <ArrowSvg>
            {
                arrActionGoToOtherAction.map((item, index) => {
                    return <Line
                        key={item?.[0]}
                        index={index}
                        nodeIdToGo={item[0]}
                        nodeIdToCome={item[1]}
                        offsetContainer={offsetContainer}
                    />;
                })
            }
            {
                props.hoverNodeId && <Line
                    index={'temp'}
                    nodeIdToGo={statusGoToOtherAction.nodeIdToGo}
                    nodeIdToCome={props.hoverNodeId}
                    offsetContainer={offsetContainer}
                />
            }
        </ArrowSvg>
    </LineArrowSvg>;
};

export default LineArrow;
